<template>
  <div class="feature-tags">
    <tag-feature-text
      v-for="(tag, index) in sortedTags"
      v-bind="tag"
      :active="activeTagIndex === index"
      :key="tag._id"
    ></tag-feature-text>
  </div>
</template>

<script>
import TagFeatureText from '@/components/TagFeatureText'

export default {
  props: {
    timeout: {
      default: 3000
    },
    tags: Array
  },

  components: {
    TagFeatureText
  },

  computed: {
    sortedTags () {
      return _.sortBy(this.tags, tag => { return -tag.pos.y })
    }
  },

  data () {
    return {
      activeTagIndex: -1,
    }
  },

  mounted () {
    this.activeTagIndex = 0

    setInterval(() => {
      this.activeTagIndex++
      if (this.activeTagIndex >= this.tags.length) {
        this.activeTagIndex = 0
      }
    }, this.timeout)
  }
}
</script>

<style>

</style>